import React from 'react';
import {Image} from '../image';
import {ImageSourcePropType, View} from 'react-native';
import {useStyles} from '../../hooks/styles';
import {HolderAvatarSize, IStateProps} from './model';
import {images} from '../../../assets/icons';

const getHolderAvatarIconBySize = (size: HolderAvatarSize) => {
  switch (size) {
    case 24: {
      return images.UserOutlined24;
    }
    case 36: {
      return images.UserOutlined36;
    }
    case 100: {
      return images.UserOutlined100;
    }
    case 160: {
      return images.UserOutlined160;
    }
    default: {
      return images.UserOutlined24;
    }
  }
};

export default ({size, preview, photo, style, color}: IStateProps) => {
  const styles = useStyles(({theme}) => ({
    avatar: {
      width: size,
      height: size,
      borderRadius: size / 2,
      alignItems: 'center',
      justifyContent: 'center',
    },
    avatarWithoutPhotoIcon: {
      color: color || theme.color.profileAvatarIcon,
    },
  }));

  const source: ImageSourcePropType = {};
  if (photo) {
    source.uri = `data:image;base64,${preview ? photo.thumbnail : photo.photo}`;
  }

  const AvatarIcon = getHolderAvatarIconBySize(size);

  return source.uri ? (
    <Image style={[style, styles.avatar]} source={source} />
  ) : (
    <View style={[style, styles.avatar, styles.avatarWithoutPhotoIcon as any]}>
      <AvatarIcon width={size} height={size} color={styles.avatarWithoutPhotoIcon.color} />
    </View>
  );
};
